export class SelectItem{
    id:number;
    label:string;
    value:string;
    spoltUrl:string;
    includeChildData:string;
    selected?:boolean;
    clntGuid?:string;
}